// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6df21a29","239":"46fa55cb","453":"3154de31","455":"423f80ca"}[chunkId] + ".chunk.js";
};